//import { H1, H4 } from '@zooplus/ui-components';
import React from 'react';

import { Cart } from '@zooplus/icons';
import { H3 } from '@zooplus/ui-components';

import styles from './PetsItem.module.scss';

export type CatsProps = {
  texts?: { text: string; url: string }[];
  image?: any;
  title?: string;
  lists?: string[];
};

export const PetsItem: React.FC<CatsProps> = ({ texts, image, title, lists }) => {
  return (
    <div className={styles.catsWrapper}>
      <div className={styles.catsBackground} style={{ backgroundImage: `url(${image})` }}></div>
      <div className={styles.catsBody}>
        <H3 className={styles.catsTitle}>{title}</H3>
        {lists && (
          <ul className={styles.catsList}>
            {lists.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
      </div>
      <div className={styles.bottomWrapper}>
        <p className={styles.text}>
          {texts &&
            texts.map((item, index) => (
              <div key={index} className={styles.bottomShopWrapper}>
                <a href={item.url}>
                  <div className={styles.shopText}>{item.text}</div>
                  <div className={styles.cartIcon}>
                    <Cart size={16} />
                  </div>
                </a>
              </div>
            ))}
        </p>
      </div>
    </div>
  );
};
